module.exports = __webpack_public_path__ + "lp/img/mic_icn-on@2x.c1129971.png";